// extracted by mini-css-extract-plugin
module.exports = {"wrap":"FileUpload_wrap__19yvE","disabled":"FileUpload_disabled__34xaT","input":"FileUpload_input__3mkZA","addIcon":"FileUpload_addIcon__1x_EZ"};